"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NONE_OWNER_VALUE = exports.ME_OWNER_VALUE = exports.ALL_OWNER_VALUE = void 0;
var ALL_OWNER_VALUE = 'all';
exports.ALL_OWNER_VALUE = ALL_OWNER_VALUE;
var ME_OWNER_VALUE = '__hs__ME';
exports.ME_OWNER_VALUE = ME_OWNER_VALUE;
var NONE_OWNER_VALUE = '';
exports.NONE_OWNER_VALUE = NONE_OWNER_VALUE;